import { useInstructionList } from "hooks/queries/useInstruction";
import { forwardRef } from "react";
import { InstallationSchema } from "types/installation";
import { formattedDate, formattedTime } from "utils/global";
import {
  getBarrierDetailsCity,
  getBarrierDetailsCustomerAddressWithTwoSideBlocking,
} from "utils/global/installationHelper";

type Props = {
  dateRangeFrom: string;
  dateRangeTo: string;
  timeFrom: string;
  timeTill: string;
  fileName: string;
  installation: InstallationSchema;
  skipOuterWrapper?: boolean;
};

const OrderPDF = forwardRef<HTMLDivElement, Props>(function OrderPDF(
  props,
  ref,
) {
  const {
    dateRangeFrom,
    dateRangeTo,
    timeFrom,
    timeTill,
    fileName,
    installation,
  } = props;

  const formattedCustomerAddress =
    getBarrierDetailsCustomerAddressWithTwoSideBlocking(installation);

  const barrierDetailsCity = getBarrierDetailsCity(installation);

  const { data: instructionList } = useInstructionList();

  const instruction = instructionList?.find(
    (item) => item.id === installation.workerInstructionNumber,
  );

  const inner = (
    <div
      ref={ref}
      style={{
        textAlign: "center",
        position: "relative",
        pageBreakAfter: "always",
        breakAfter: "page",
      }}
    >
      <div style={{ position: "absolute", right: 0, top: 0 }}>{fileName}</div>

      <div style={{ fontSize: "9rem", fontWeight: 800, lineHeight: 1.3 }}>
        {dateRangeFrom === dateRangeTo ? (
          <div>
            <div style={{ fontWeight: 500 }}>am</div>
            <div style={{ fontSize: "10rem" }}>
              {formattedDate(dateRangeFrom)}
            </div>
          </div>
        ) : (
          <div>
            <div>
              <span style={{ fontWeight: 500 }}>ab</span>&nbsp;
              {formattedDate(dateRangeFrom)}
            </div>
            <div>
              <span style={{ fontWeight: 500 }}>bis</span>&nbsp;
              {formattedDate(dateRangeTo)}
            </div>
          </div>
        )}
        <div>
          {formattedTime(timeFrom)} - {formattedTime(timeTill)} h
        </div>
      </div>
      <div
        style={{ fontSize: "12px", display: "flex", flexDirection: "column" }}
      >
        <span>Adresse: {formattedCustomerAddress},</span>
        <span>Absperrung: {barrierDetailsCity},</span>
        <span>{instruction?.code}</span>
      </div>
    </div>
  );

  if (props.skipOuterWrapper) {
    return inner;
  }

  return <div style={{ display: "none" }}>{inner}</div>;
});

export default OrderPDF;
